<template>
  <div class="page-box" v-loading="lockStatus" element-loading-text="数据加载中......" element-loading-spinner="el-icon-loading">
    <corner-box>
    <div class="content-box">
      <div class="top-box">
        <div class="file-box fl" id="fileBox">
          <input type="file" id="file" class="file-path" @change="changePic()" >
        </div>
        <div class="title-box fl">
          <div class="title1">{{uesrName}}</div>
          <div class="title2">{{numb}}</div>
        </div>
      </div>
      <div class="center-box">
        <div class="title3">项目信息</div>
        <div class="peoject-info">
          <div class="peoject-left fl">
            <div>项目开始时间：</div>
            <div>项目名称：</div>
            <div>负责分部：</div>
          </div>
          <div class="peoject-right fl">
            <div>{{startTime}}</div>
            <div>{{projectName}}</div>
            <div>{{branch}}</div>
          </div>
        </div>
        <div class="title3">个人信息</div>
        <div class="peoject-info">
          <div class="peoject-left fl">
            <div><span style="color:red;">* </span>昵称：</div>
            <div><span style="color:red;">* </span>手机号码：</div>
            <div>邮箱地址：</div>
          </div>
          <div class="peoject-right fl">
            <div>
              <el-input @change="checkName(petName)" type="text" v-model="petName" placeholder="请输入昵称" class="w310" clearable ></el-input>
            </div>
            <div>
              <el-input @change="checkTelNum(telnum)" onkeyup="value=value.replace(/\D/g,'')" maxlength="11" v-model="telnum" placeholder="请输入手机号码" class="w310" clearable ></el-input>
            </div>
            <div>
              <el-input @change="checkEmail(emailAdd)" v-model="emailAdd" placeholder="请输入邮箱地址" class="w310" clearable ></el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-box">
        <div class="btn">
          <el-button class="primary" @click="handleLandDialog()">重置登录密码</el-button>
          <el-button class="primary" v-if="showOperation" @click="handleOperationDialog()">重置操作密码</el-button>
        </div>
        <div class="btn">
          <el-button class="long-btn" @click="closePage()">取 消</el-button>
          <el-button class="long-btn primary" @click="saveData()">保 存</el-button>
        </div>
        <el-dialog title="重置登录密码" class="pswd-dialog" :visible.sync="landDialog" width="36%">
          <div class="pswd-box">
            <div class="fl">
              <div>原始密码：</div>
              <div>修改密码：</div>
              <div>确认密码：</div>
            </div>
            <div class="right-box fl">
              <el-input type="password" onkeyup="value=value.replace(/[^\w_]/g,'')" v-model="originalLand" class="w310" clearable></el-input>
              <el-input type="password" onkeyup="value=value.replace(/[^\w_]/g,'')" v-model="landPswd1" class="w310" clearable></el-input>
              <el-input type="password" onkeyup="value=value.replace(/[^\w_]/g,'')" v-model="landPswd2" class="w310" clearable></el-input>
            </div>
          </div>
          <span slot="footer">
            <el-button class="primary" @click="landDialog = false">取 消</el-button>
            <el-button class="primary" @click="handleLand()">确 认</el-button>
          </span>
        </el-dialog>
        <el-dialog title="重置操作密码" class="pswd-dialog" :visible.sync="operationDialog" width="36%">
          <div class="pswd-box">
            <div class="fl">
              <div>原始密码：</div>
              <div>修改密码：</div>
              <div>确认密码：</div>
            </div>
            <div class="right-box fl">
              <el-input type="password" onkeyup="value=value.replace(/[^\w_]/g,'')" v-model="originalOperation" class="w310" clearable></el-input>
              <el-input type="password" onkeyup="value=value.replace(/[^\w_]/g,'')" v-model="operationPswd1" class="w310" clearable></el-input>
              <el-input type="password" onkeyup="value=value.replace(/[^\w_]/g,'')" v-model="operationPswd2" class="w310" clearable></el-input>
            </div>
          </div>
          <span slot="footer">
            <el-button class="primary" @click="operationDialog = false">取 消</el-button>
            <el-button class="primary" @click="handleOperation()">确 认</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
    </corner-box>
  </div>
</template>
<script>
import cornerBox from "../../components/cornerBox";

export default { 
  name: "accountManagement",
  data() {
    return {
      lockStatus: "",
      imgFile: {},
      uesrName: "",
      numb: "",
      startTime: "",
      projectName: "",
      branch: "",
      petName: "",
      oldPetName: "",
      telnum: "",
      oldTelnum: "",
      emailAdd: "",
      oldEmailAdd: "",
      landDialog: false,
      originalLand: "",
      landPswd1: "",
      landPswd2: "",
      showOperation: false,
      operationDialog: false,
      originalOperation: "",
      operationPswd1: "",
      operationPswd2: "",
    }
  },
  components: {
    cornerBox
  },
  mounted() {
    this.getData();
  },
  methods: {
    changePic() {
      var f = document.getElementById('file').files[0];
      if( f.type === "image/jpg" || f.type === "image/png" || f.type === "image/jpeg"){
        if( f.size <= 512000 ) {
          var reads = new FileReader();
          reads.readAsDataURL(f);
          let $this = this;
          reads.onload = function(e) {
            document.getElementById('fileBox').style.backgroundImage ="url("+this.result+")";
          }
          this.imgFile = f;
        } else {
          this.$message.error("上传的图片不能超过500KB!");
        }
      } else {
        this.$message.error("请选择格式为*.jpg、*.png、*.jpeg的图片");
      }
    },
    checkName(name) {
      if( !name) {
        this.$message.error("请输入昵称！");
      }
    },
    checkTelNum(num) {
      let re1 = /^(13[0-9]|14[5|7]|15[0|1|2|3|4|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/;
      if (!re1.test(num)) {
        this.$message.error("请输入正确的手机号码！");
      }
    },
    checkEmail(value) {
      let re2 = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if(!re2.test(value) && value !== "") {
        this.$message.error("请输入正确的邮箱地址");
      }
    },
    handleLandDialog() {
      this.originalLand = "";
      this.landPswd1 = "";
      this.landPswd2 = "";
      this.landDialog = true;
    },
    handleOperationDialog() {
      this.originalOperation = "";
      this.operationPswd1 = "";
      this.operationPswd2 = "";
      this.operationDialog = true;
    },
    handleLand() {
      if( this.originalLand === "") {
        this.$message.error("请输入原始密码！");
      } else {
        if ( this.landPswd1 === "") {
          this.$message.error("请输入修改密码！");
        } else {
          if( this.landPswd1 === this.landPswd2) {
            let landParam = {};
            landParam.oldPassword = this.$md5(this.originalLand);
            landParam.password = this.$md5(this.landPswd1);
            this.$post('accountmanagement/updateuserdata', landParam).then(
              (response)=>{
                if( response.indexOf("操作成功" ) !== -1 ) {
                  this.landDialog = false;
                }
              },
              (err) => {
                console.log(err);
              }
            )
          } else {
            this.$message.error("两次密码输入不一致！");
          }
        }
      }
    },
    handleOperation() {
      if( this.originalOperation === "") {
        this.$message.error("请输入原始密码！");
      } else {
        if ( this.operationPswd1 === "") {
          this.$message.error("请输入修改密码！");
        } else {
          if( this.operationPswd1 === this.operationPswd2) {
            let operationParam = {};
            operationParam.oldOperatePassword = this.$md5(this.originalOperation);
            operationParam.operatePassword = this.$md5(this.operationPswd1);
            this.$post('accountmanagement/updateuserdata', operationParam).then(
              (response)=>{
                if( response.indexOf("操作成功" ) !== -1 ) {
                  this.operationDialog = false;
                }
              },
              (err) => {
                console.log(err);
              }
            )
          } else {
            this.$message.error("两次密码输入不一致！");
          }
        }
      }
    },
    getData() {
      this.lockStatus = true;
      this.$get('accountmanagement/getuserdata', []).then(
        (response) => {
          this.lockStatus = false;
          this.uesrName = response.userInfo.nickName;
          this.numb = response.userInfo.phoneNumber;
          this.startTime = response.projectInfo.startDate;
          this.projectName = response.projectInfo.projectName;
          this.branch = response.projectInfo.divisions;
          this.petName = response.userInfo.nickName;
          this.oldPetName = response.userInfo.nickName;
          this.telnum = response.userInfo.phoneNumber;
          this.oldTelnum = response.userInfo.phoneNumber;
          this.emailAdd = response.userInfo.emailAddress;
          this.oldEmailAdd = response.userInfo.emailAddress;
          if(response.userInfo.avatarUrl) {
            document.getElementById('fileBox').style.backgroundImage ="url("+response.userInfo.avatarUrl+")";
            this.$store.commit('changeUserPic', response.userInfo.avatarUrl)
          }
          if(response.isOperatePassword === 1) {
            this.showOperation = true;
          }
        },
        (err) => {
          console.log(err);
          this.lockStatus = true;
        }
      )
    },
    saveData() {
      var canSave = false;
      var form = new FormData();
      if( this.petName !== "") {
        if (this.petName !== this.oldPetName ) {
          form.append("nickName", this.petName);
          canSave = true;
        }
      } else {
        this.$message.error("请输入昵称！");
      }
      let str1 = /^(13[0-9]|14[5|7]|15[0|1|2|3|4|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/;
      if ( str1.test(this.telnum)) {
        if( this.telnum !== this.oldTelnum ){
          form.append("phoneNumber", this.telnum);
          canSave = true;
        }
      } else {
        this.$message.error("请输入正确的手机号码！");
      }
      if (this.emailAdd !== this.oldEmailAdd && this.emailAdd !== "") {
        let str2 = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (str2.test(this.emailAdd)) {
          form.append("emailAddress", this.emailAdd);
          canSave = true;
        } else {
          this.$message.error("请输入正确的邮箱地址");
        }
      }
      if (this.imgFile.name) {
        form.append("userPhoto", this.imgFile);
        canSave = true;
      }
      let config1 = {
        method: 'POST',
        url: this.rootUrl + 'accountmanagement/updateuserdata',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: form,
      };
      let $this = this;
      if( canSave ){
        return this.$axios(config1).then(function (response) {
          if( response.indexOf("操作成功" ) !== -1 ) {
            $this.getData();
          }
        }, err => {
          console.log(form)
        });
      }
    },
    closePage() {
      this.$router.push("/generalSituation");
    }
  }
}
</script>
<style scoped lang="scss">
.page-box {
  padding: 40px 200px;
  color: #fff;
  .content-box {
    padding: 30px 0;
    margin: auto;
    border: 1px solid #083550;
    background: radial-gradient(#000000,#001231);
    .top-box {
      overflow: hidden;
      width: 475px;
      margin: 0 auto;
      .file-box {
        position: relative;
        width: 130px;
        height: 130px;
        border: 1px solid #1384c5;
        border-radius: 65px;
        background-image: url(../../assets/images/header/header_default.png);
        background-repeat:no-repeat;
        background-size:100% 100%;
        .file-path {
          width: 100%;
          height: 100%;
          border-radius: 65px;
          opacity: 0;
        }
      }
      .title-box {
        margin-left: 40px;
        .title1 {
          margin-top: 25px;
          padding: 15px 0;
          font-size: 20px;
          font-weight: bold;
        }
        .title2 {
          font-size: 16px;
        }
      }
    }
    .center-box {
      padding: 30px 10px;
      width: 475px;
      margin: 0 auto;
      .title3 {
        font-size: 18px;
      }
      .peoject-info {
        overflow: hidden;
        font-size: 14px;
        .peoject-left {
          width: 140px;
          div {
            line-height: 40px;
            text-align: right;
          }
        }
        .peoject-right {
          width: 315px;
          div {
            line-height: 40px;
          }
        }
      }
    }
    .bottom-box {
      padding-left: 150px;
      width: 475px;
      margin: 0 auto;
      .btn {
        button {
          margin: 0 16px 16px 0;
        }
        .long-btn {
          width: 136px;
        }
      }
      .pswd-dialog {
        .pswd-box {
          overflow: hidden;
          width: 385px;
          margin: 0 auto;
          font-size: 14px;
          line-height: 50px;
          color: #fff;
          .right-box {
            width: 310px;
          }
        }
      }
    }
  }
}
</style>